import React from 'react';
import { Icon } from '@mui/material';

const styles = {
  imageIcon: {
    height: '100%',
    width: '100%',
  },
  iconRoot: {
    textAlign: 'center',
  },
};

function BaseIcon({ path, altText }) {
  return (
    <Icon classes={{ root: styles.iconRoot }}>
      <img alt={altText || ''} style={styles.imageIcon} src={path} />
    </Icon>
  );
}

export default BaseIcon;
